import { darkAssets } from './assets';
// TODO: minimalChatTokens

export const darkTheme = {
	id: 'dark',
	assets: darkAssets,
};
